import React from "react";
import { IIcons } from "./icons";

const AlertIcon = ({ fillColor }: IIcons.IconProps) => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25ZM11.6588 19.1063C11.9708 19.4063 12.3428 19.5563 12.7748 19.5563C13.2068 19.5563 13.5728 19.4063 13.8728 19.1063C14.1728 18.7943 14.3228 18.4223 14.3228 17.9903C14.3228 17.5583 14.1728 17.1923 13.8728 16.8923C13.5728 16.5923 13.2068 16.4423 12.7748 16.4423C12.3428 16.4423 11.9708 16.5923 11.6588 16.8923C11.3588 17.1923 11.2088 17.5583 11.2088 17.9903C11.2088 18.4223 11.3588 18.7943 11.6588 19.1063ZM11.5508 6.56028V10.2683L11.8028 15.0203H13.7288L13.9808 10.2683V6.56028H11.5508Z"
      fill="#9E7C05"
      className={fillColor}
    />
  </svg>
);
export default AlertIcon;
